import React from 'react';

const XPO_LOGO = 'https://customer-assets.emergentagent.com/job_xpo-revamp/artifacts/m5l5624g_xpo_logo_png-02.png';

const Footer = () => {
  const footerLinks = {
    legal: [
      { name: 'Enrollment Agreement', href: '#' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'Security Policy', href: '#' },
      { name: 'Email Policy', href: '#' },
    ],
    company: [
      { name: 'Why XPO', href: '#' },
      { name: 'XPO Indexes', href: '#indexes' },
      { name: 'Rewards and Recognition', href: '#' },
      { name: 'Blog', href: '#blog' },
    ],
    terms: [
      { name: 'GDPR Compliance and Cookie Policy', href: '#' },
      { name: 'General Terms of Service', href: '#' },
      { name: 'Subsidiary Agreement', href: '#' },
      { name: 'ICANN Registrant Rights', href: '#' },
    ],
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      {/* Links Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <a href="#home" className="flex items-center mb-4">
              <img 
                src={XPO_LOGO} 
                alt="XPO" 
                className="h-12 w-auto object-contain"
              />
            </a>
            <p className="text-gray-400 text-sm leading-relaxed">
              XPO is an investment platform offering trading in forex, cryptocurrencies, CFDs, and indices. 
              It provides diverse investment opportunities across global markets.
            </p>
          </div>
          
          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Terms Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Terms & Policies</h4>
            <ul className="space-y-2">
              {footerLinks.terms.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="space-y-4 text-xs text-gray-500 leading-relaxed">
            <p>
              <span className="text-gray-400">Copyright © 2016-{new Date().getFullYear()}. Xeno Portfolio</span>
            </p>
            
            <p>
              Xeno Portfolio Ltd, registered by the Financial Services Commission (FSC) under the Business Companies Act, 
              2004 (Company number <span className="text-gray-400 font-medium">2129747</span>) in BRITISH VIRGIN ISLANDS as a BVI BUSINESS COMPANY.
            </p>
            
            <p>
              Xeno Portfolio LLC, registered by the Financial Services Commission (FSC) under section 22 of the Limited 
              Liability Companies Act (No. 29 of 2023) (REGISTRATION NO: <span className="text-gray-400 font-medium">FSC/200/LLC 2298/24</span>) in BELIZE.
            </p>
            
            <p className="text-yellow-500/80">
              Xeno Portfolio LTD does not offer financial services to residents of certain jurisdictions, including, 
              but not limited to: Cuba, North Korea, Syria, Sudan, Zimbabwe, Israel, the Islamic Republic of Iran, 
              Myanmar, Libya, Mali, Nicaragua, Central African Republic.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} XPO. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              {['Twitter', 'LinkedIn', 'Telegram', 'Discord'].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="text-gray-500 hover:text-cyan-400 transition-colors text-sm"
                >
                  {social}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
